/*eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import FormSearchInput from '../inputs/FormSearchInput';
import TextInput from '../inputs/TextInput';
import SelectInput from '../inputs/SelectInput';
import Select from 'react-select';
import { Post, Get, Delete, Put, GetwithQueryString } from '../../utility/fetch';
import { URLAPI } from '../../utility/ApiMethods';
import { GiTrashCan } from 'react-icons/gi';
import { GrEdit } from 'react-icons/gr';
import data from '../../data';
import { GiRecycle } from 'react-icons/gi';
import Cookies from 'js-cookie';
import { deleteMessage, errorMessage, successMessage } from '../../resources/alert';
import LoadingSpinner from '../../resources/loadingSpinner';
const bottomBorder = {
    borderBottom: '.5px solid rgba(99,99,99,.6)',
};
const tableBorder = {
    border: 'none',
    borderRight: '1px solid #0000000A',
    borderBottom: '1px solid #0000000A',
};

class AssignAssetApprovalSequenceForm extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            approvalId: '',
            sequence: '',
            button: 'Save Record',
            records: [],
            employees: [],
            employee: 0,
            employeeName: '',
            bgColor: '',
            requestId: 0,
            approval: [],
            loading: false,
            bgColor: 'white',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleEmpOption = (approvalId) => {
        // this.setState({
        //   approvalId: e.target.options[e.target.selectedIndex].text,
        //   [app.target.name]: e.target.value,
        //   approvalId

        // }, () => console.log('option selected', this.state.approvalId))
        this.setState({ approvalId }, () => console.log('option selected', this.state.approvalId));
    };

    // getEmployee = (data) => {
    //   console.log(data);

    //   if (this._isMounted) {
    //     let _records = data
    //     this.setState({ employee: _records, loading: false });

    //   }
    // };

    getEmployee = (data) => {
        // let _title = data

        // let records = [];

        // if (_title != "") {
        //   _title.forEach(function (l, index) {
        //     let sn = { value: l.id, label: l.firstName + ' ' + l.lastName, };
        //     records.push(sn)
        //   })
        // }
        // this.setState({ employee: records, loading: false });

        console.log('Logging employees data ', data);

        if (this._isMounted) {
            let _records = Array.isArray(data) ? data : [];

            this.setState({ employees: _records, loading: false });
        }
    };

    getApproval = (data) => {
        console.log(data);

        if (this._isMounted) {
            let _records = Array.isArray(data) ? data : [];

            this.setState({ approval: _records, loading: false });
        }
    };

    componentDidMount() {
        this._isMounted = true;
        try {
            // Get(URLAPI.employee, this.getEmployee);
            // GetwithQueryString({name: this.state.employee}, URLAPI.employee, this.getEmployee);
            Get(URLAPI.requestApprovalSetups.Get, this.getApproval);
        } catch (err) {
            console.log(err);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    validateForm = () => {
        const { employeeName, sequence } = this.state;

        if (!employeeName) return 'Please, Search & Select Employee';
        if (!sequence) return 'Please, Enter Approval Sequence';
        // if (!sequence) return 'Please, Enter sequence';
        return null;
    };

    onSubmit = (e) => {
        e.preventDefault();

        let error_data = this.validateForm();

        if (error_data) {
            errorMessage(error_data);
        } else if (error_data !== this.validateForm) {
            let request = {
                id: this.state.requestId,
                approvalId: parseInt(this.state.employee),
                sequence: parseInt(this.state.sequence),
                //status: 0,
            };

            if (this.state.button === 'Save Record') {
                this.onSubmitSave(request);
            } else if (this.state.button === 'Update') {
                this.onSubmitUpdate(request);
            }
        }
    };

    onSubmitSave = (data) => {
        this.setState({ loading: true }, () => {
            Post(data, URLAPI.requestApprovalSetups.Post, this.onSubmitAfterSave);
        });
        console.log(data);
    };

    onSubmitAfterSave = (data) => {
        console.log(data);
        if (data.code === 1) {
            successMessage(data.message);

            Get(URLAPI.requestApprovalSetups.Get, this.getApproval);

            //clone the records in array
            const cat = [...this.state.records];

            //create array of data submitted
            let req = {
                id: parseInt(data.id),
                approvalId: parseInt(this.state.employee),
                sequence: parseInt(this.state.sequence),
                //createdBy: this.state.createdBy,
                //status: 1,
            };

            //update the new record into the array
            cat.push(req);

            //commit the new record into array
            this.setState({ records: req, loading: false, employeeName: '', sequence: '' });
        } else if (data.code === 0) {
            errorMessage(data.message);
            this.setState({
                loading: false,
                employeeName: '',
                sequence: '',
            });
        } else if (data.code === 0) {
            errorMessage(data.message);
            //console.log(data.message);
            this.setState({ loading: false, employeeName: '', sequence: '' });
        }
    };

    handleDeleteRecord(record) {
        deleteMessage(() => this.onDelete(record));
    }

    onDelete = (record) => {
        console.log('clicked');
        if (record !== '') {
            this.setState({ loading: true }, () => {
                Delete(URLAPI.requestApprovalSetups.Delete + '/' + record.id, this.onAfterDelete);
            });
        }
    };

    onAfterDelete = (res) => {
        if (res.code === 1) {
            // console.log(res);
            this.setState({ loading: false });
            successMessage(res.message);
            Get(URLAPI.requestApprovalSetups.Get, this.getApproval);

            this.setState({ approval: this.state.approval.filter((rec) => rec.id !== res.id) });
            // this.handleCancel();
        } else if (res.status === 'failed') {
            errorMessage(res.message);
            this.setState({ loading: false, visible: false });
        } else {
            errorMessage(res.message);
        }
    };

    onEdit = (item) => {
        //set record to state
        console.log('onedit', item);
        if (item !== null) {
            this.setState({
                button: 'Update',
                requestId: item.id,
                //approvalId: item.approvalid,
                employeeName: item.firstName + ' ' + item.lastName,
                employee: item.approvalid,
                sequence: item.sequence,
                bgColor: '#c2f542',
            });
        }
    };

    onSubmitUpdate = (request) => {
        console.log(request);
        if (request.id) {
            let data = {
                id: this.state.requestId,
                approvalId: parseInt(this.state.employee),
                sequence: parseInt(this.state.sequence),
            };
            // this.setState({ loading: true }, () => {
            //   Put(data, URLAPI.requestApprovalSetups.Put + "/" + members.id, this.onSubmitAfterUpdate);

            // });
            this.setState(
                {
                    loading: true,
                },
                () => {
                    Put(data, `${URLAPI.requestApprovalSetups.Put}/${request.id}`, this.onSubmitAfterUpdate);
                },
            );
        }
    };

    onSubmitAfterUpdate = (data) => {
        console.log(data);

        if (data.code === 1) {
            successMessage(data.message);
            Get(URLAPI.requestApprovalSetups.Get, this.getApproval);

            //get the index of the edited record
            let index = this.state.approval.findIndex((x) => parseInt(x.id) === parseInt(data.id));

            //clone the record
            let _records = [...this.state.approval];

            //check if the record exist
            if (index >= 0) {
                //update the variables with the new ones

                _records[index].approvalId = this.state.employee;
                _records[index].sequence = parseInt(this.state.sequence);
            }

            //commit to state
            this.setState({ approval: _records, sequence: '', button: 'Save Record', bgColor: 'white', employee: '', employeeName: '' });

            //this.handleCancel();
        } else if (data.code === 0) {
            errorMessage(data.message);
            this.setState({ loading: false, button: 'Save Record', sequence: '', bgColor: 'white' });
        } else {
            errorMessage('Something went wrong while trying to update record Please, try again later.');
            this.setState({ loading: false, button: 'Save Record', bgColor: 'white' });
        }
    };

    handleClear = () => {
        //clear all action
        this.setState({
            loading: false,
            sequence: '',
            approvalId: '',
            button: 'Save Record',
            employeeName: '',
            employee: '',
            employees: '',
            bgColor: 'white',
        });
    };

    handleStateChange = (name, value) => {
        this.setState({ [name]: value });
    };

    render() {
        const { sequence, button, loading } = this.state;
        return (
            <>
                {loading ? (
                    <LoadingSpinner />
                ) : (
                    <div className='row'>
                        <div className='col-4'>
                            <div
                                className='form-group p-10 m-l-10 pd-b-0  h-10'
                                style={{ background: this.state.bgColor }}>
                                {/* <TextInput
                label='Approval Id'
                type='number'
                name='approvalId'
                value={approvalId}
                color='rgba(112,112,112,.7)'
                onChange={(e) => this.handleChange(e)}
              /> */}
                                <br />
                                <FormSearchInput
                                    className='w-100'
                                    displayType='names'
                                    color='rgba(112,112,112,.7)'
                                    searchValue={this.state.employees}
                                    value={this.state.employeeName}
                                    setSuggestions={this.handleStateChange}
                                    displayType='names'
                                    stateName={this.handleStateChange}
                                    displayName='employeeName'
                                    stateValue='employee'
                                    dropDownName='employees'
                                    label='select role'
                                    // onChange={e => this.handleEmpOption(e)}
                                    onChange={(e) => {
                                        this.setState({ employeeName: e.target.value });
                                        GetwithQueryString(
                                            URLAPI.employee,
                                            { name: 'name', value: e.target.value },
                                            this.getEmployee,
                                        );
                                    }}
                                    selectReliefOfficer={this.handleStateChange}
                                />

                                {/* 
                <Select value={this.state.approvalId} options={this.state.employee} isMulti={true}
                  placeholder="Select Employee"
                  onChange={e => this.handleEmpOption(e)}
                  autoComplete="on" /> */}
                                <br />
                                <TextInput
                                    label='sequence'
                                    value={sequence}
                                    name='sequence'
                                    type='number'
                                    color='rgba(112,112,112,.7)'
                                    onChange={(e) => this.handleChange(e)}
                                />
                                {/* <FormSearchInput label='Select Role' color='rgba(112,112,112,.7)' />
            <TextInput label='Sequence' type='number' color='rgba(112,112,112,.7)' /> */}
                                {/* <div className='h-100'> */}
                                <div
                                    className='w-100 m-b-auto flex flex-v-center space-between m-t-10'
                                    style={{ alignSelf: 'flex-end' }}>
                                    <button className='btn btn-large w-49 p-10' type='button' onClick={this.onSubmit}>
                                        {button}
                                    </button>
                                    <button
                                        className='btn-large w-49 cancel-btn p-10'
                                        type='button'
                                        onClick={this.handleClear}>
                                        Cancel
                                    </button>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>

                        <div className='col-8'>
                            <div
                                id='bordered-table'
                                className='table-view '
                                style={{
                                    borderCollapse: 'collapse',
                                    borderSpacing: '5px 15px',
                                    // border: 'none',
                                    ...this.props.overrideTableStyles,
                                }}>
                                <div
                                    className='table-header'
                                    style={{
                                        backgroundColor: `${this.props.headerBGColor || '#43425D'}`,
                                        color: `${this.props.headerColor || 'white'}`,
                                    }}>
                                    <div className='table-row'>
                                        <div className='th case title w-25' style={{ ...bottomBorder }}>
                                            <GiRecycle fontSize='20px' />
                                        </div>
                                        <div className='th case title w-25' style={{ ...bottomBorder }}>
                                            <p>Title</p>
                                        </div>
                                        <div className='th case title w-25' style={{ ...bottomBorder }}>
                                            <p>Approval Sequence</p>
                                        </div>
                                        <div className='th case title w-25' style={{ ...bottomBorder }}>
                                            <p>Last Updated</p>
                                        </div>
                                        <div className='th case title w-25' style={{ ...bottomBorder }}>
                                            <p>Updated By</p>
                                        </div>
                                        <div className='th case title w-25' style={{ ...tableBorder }}>
                                            <p>Action</p>
                                        </div>
                                    </div>
                                </div>
                                {this.state.approval.length !== 0 ? (
                                    <h3>No ratio created</h3>
                                ) : (
                                    <div className='table-body no-border'>
                                        {this.state.approval.map((item) => (
                                            <div className='table-row no-border' key={item.id}>
                                                <div className='td left-text font-sz-22 pointer' style={{ ...tableBorder }}>
                                                    <GrEdit onClick={() => this.onEdit(item)} />
                                                </div>
                                                <div
                                                    className='td font-sz-13'
                                                    style={{
                                                        ...tableBorder,
                                                    }}>
                                                    {item.firstName + ' ' + item.lastName}
                                                </div>
                                                <div className='td font-sz-13' style={{ ...tableBorder }}>
                                                    {item.sequence || null}
                                                </div>
                                                <div className='td font-sz-13' style={{ ...tableBorder }}>
                                                    {item.date}
                                                </div>
                                                <div className='td font-sz-13' style={{ ...tableBorder }}>
                                                    {Cookies.get('_FullName')}
                                                </div>

                                                <div className='td m-l-10 font-sz-22 pointer' style={{ ...tableBorder }}>
                                                    <GiTrashCan onClick={() => this.handleDeleteRecord(item)} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default AssignAssetApprovalSequenceForm;
